import { z } from 'zod';

/**
 * What a member changes about themselves from Settings' Profile: their
 * name, which every company they are in shows. Email is their login and the
 * phone number is tied to text sign-in, so neither is asked
 * (PUT /auth/me takes the name alone).
 */
export const profileSchema = z.object({
  name: z.string().trim().min(1, 'Enter your name.'),
});

export type ProfileValues = z.infer<typeof profileSchema>;
